{
  "doc_empty": "Начните писать текст или введите \"/\", чтобы открыть список команд",
  "checkbox": "Добавьте описание задачи или пункт проверки",
  "codeblock": "Добавьте в блок код или текст",
  "deflist_term": "Термин",
  "deflist_desc": "Определение",
  "heading": "Заголовок",
  "cut_title": "Заголовок ката",
  "cut_content": "Добавьте текст, который отобразится по нажатию на заголовок",
  "note_title": "Заголовок примечания",
  "note_content": "Добавьте содержание для примечания",
  "block": "Блок с оформлением",
  "layout_cell": "Текст",
  "table_cell": "Текст",
  "select_filter": "Поиск"
}
